import { ValidationResult } from './validation-result';

export class MessageSuffix {
    id: number;
    requestTypeId: number;
    requestStatusId: number;
    activeStatus: string | null;
    lastUpdated: string | null;
    messageSuffix: string | null;
    agencyId: number | null;
    serviceDefId: number | null;

    constructor() {
        this.id = 0;
        this.requestTypeId = 0;
        this.requestStatusId = 0;
        this.activeStatus = null;
        this.lastUpdated = null;
        this.messageSuffix = '';
        this.agencyId = null;
        this.serviceDefId = null;
    }

    validateRecord(): ValidationResult {
        const vr: ValidationResult = new ValidationResult();

        if (!this.messageSuffix || this.messageSuffix.trim().length === 0) {
            vr.focus_field = 'messageBody';
            vr.error = 'Error: An message reponse is required';
            return vr;
        }

        return vr;
    }

    static filterByRequestTypeAndStatus(MessageSuffixes: MessageSuffix[], requestTypeId: number, requestStatusId: number): MessageSuffix[] {
        return MessageSuffixes.filter(suffix => 
            suffix.requestTypeId === requestTypeId && suffix.requestStatusId === requestStatusId
        );
    }
}
